jQuery(document).ready(function($) {

    /*Cookie*/

    function getCookie() {
        var cookie = window.localStorage.getItem('cookie-queen');
        if (cookie == 'active') {
            $('.pop-up-cookie').addClass('d-none');
        } else {
            $('.pop-up-cookie').removeClass('d-none');
        }
    }

    getCookie();

    $('.close-cookie').click(function(e) {
        e.preventDefault();
        window.localStorage.setItem('cookie-queen', 'active');
        $('.pop-up-cookie').addClass('remove-cookie');
    });
    /*Cookie*/

    $('.scrool').click(function(e) {
        e.preventDefault();
        var id = $(this).attr('href');
        targetOffset = $(id).offset().top - 70;
        $('html, body').animate({
            scrollTop: targetOffset
        }, 500)

    })


    //Scrool header bar
    function fixedHeader() {
        var height = $(window).scrollTop(); //getting the scrolling height of window
        if (height > 70) {
            $(".main-header").addClass("navbar-faded");
        } else {
            $(".main-header").removeClass("navbar-faded");
        }
    }

    fixedHeader();

    if ($(".main-header").length) {
        $(window).on("scroll", function() {
            // this will work when your window scrolled.
            fixedHeader();
        });
    }

    var $window = $(window);
    // Scroll up
    var $scrollup = $('.scrollup');

    $window.scroll(function() {
        if ($window.scrollTop() > 100) {
            $scrollup.addClass('show');
        } else {
            $scrollup.removeClass('show');
        }
    });

    $scrollup.on('click', function(evt) {
        $("html, body").animate({ scrollTop: 0 }, 600);
        evt.preventDefault();
    });


    new WOW().init();

    var lazyLoadInstance = new LazyLoad({
        // Your custom settings go here
    });
    lazyLoadInstance.update();
    
});

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};